import React from 'react';
import _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { AddGroupsButton } from '../../../userManagement/components/AddGroupsButton';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { SpaceHeaderWithTotalItemsCount } from '../Header/SpaceHeaderWithTotalItemsCount';

export interface AllGroupsSpaceOwnProps {
  readonly siteName: string;
}

export interface AllGroupsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedGroups: number;
  readonly canSessionUserManageUsers: boolean;
}

export interface AllGroupsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllGroupsSpaceProps = AllGroupsSpaceOwnProps & AllGroupsSpaceStateProps & AllGroupsSpaceDispatchProps;

export class AllGroupsSpace extends React.PureComponent<AllGroupsSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.groups() });
    this.props.requestSpaceContents();
  }

  public componentDidUpdate(prevProps: AllGroupsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.groups()}
          testId={'groups'}
          count={this.props.numberOfFetchedGroups}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addGroupButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.groupsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }

  private addGroupButton = () => {
    return (
      <AddGroupsButton
        buttonText={Messages.addGroup()}
        canSessionUserManageUsers={this.props.canSessionUserManageUsers}
      />
    );
  }
}
